export { default, type TErrorType } from './error-template';
